import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Contact from "../components/Contact";
import CuratedReviews from "../components/CuratedReviews";
import SocialProof from "../components/SocialProof";
import {
  SEO,
  localBusinessSchema,
  breadcrumbSchema,
} from "../components/SEO";
import { BRAND, LOGO_URL } from "../mock";
import { Star, ExternalLink } from "lucide-react";
import { openExternal } from "../lib/openExternal";

export default function ReviewsPage() {
  const url = `${BRAND.url}/reviews`;
  return (
    <div className="grain bg-jester-deep text-white min-h-screen">
      <SEO
        title="Google Reviews | Jester Werks Ceramic Coating Mississauga"
        description="Read 250+ verified 5-star Google reviews for Jester Werks. Mississauga's most-reviewed Gtechniq ceramic coating studio. Real customers, real cars, real results."
        canonical={url}
        schemas={[
          localBusinessSchema(),
          breadcrumbSchema([
            { name: "Home", url: `${BRAND.url}/` },
            { name: "Reviews", url },
          ]),
        ]}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 md:pt-44 md:pb-24 overflow-hidden">
        <div className="absolute -top-20 right-1/4 w-[600px] h-[600px] rounded-full bg-jester-purple/15 blur-[140px]" />
        <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] rounded-full bg-acid/8 blur-[140px]" />
        <img
          src={LOGO_URL}
          alt=""
          aria-hidden="true"
          className="hidden lg:block absolute right-[8%] top-1/2 -translate-y-1/2 w-[300px] opacity-60 spin-slow"
        />

        <div className="relative max-w-7xl mx-auto px-6 md:px-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#A8E000]/40 bg-[#A8E000]/8 backdrop-blur-sm mb-8">
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-3.5 h-3.5"
                    style={{ color: "#FDC814", fill: "#FDC814" }}
                  />
                ))}
              </div>
              <span className="text-xs font-label uppercase tracking-[0.3em] text-acid">
                {BRAND.rating.value} · {BRAND.rating.count}+ Verified Reviews
              </span>
            </div>

            <h1 className="font-display text-[12vw] md:text-[6.5rem] leading-[0.92] tracking-tight">
              REAL
              <br />
              <span className="text-jester">REVIEWS.</span>
              <br />
              <span className="font-marker text-acid text-[7vw] md:text-[2.8rem] inline-block mt-2">
                no edits, no filters.
              </span>
            </h1>
            <p className="mt-7 text-lg md:text-xl text-white/80 max-w-2xl leading-relaxed">
              {BRAND.rating.count}+ verified Google reviews from real{" "}
              Mississauga and Toronto clients. Every review is streamed live
              from our Google Business profile. no cherry-picking, no
              testimonials we wrote ourselves.
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-3">
              <a
                href={BRAND.socials.googleWriteReview}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 h-12 rounded-full bg-acid hover:bg-[#bff020] text-[#120127] font-label tracking-[0.2em] text-sm uppercase transition-colors shadow-[0_0_30px_rgba(168,224,0,0.3)]"
               onClick={(e) => { e.preventDefault(); openExternal(BRAND.socials.googleWriteReview); }}>
                Leave a Review <ExternalLink className="w-4 h-4" />
              </a>
              <a
                href="/#contact"
                className="inline-flex items-center gap-2 px-6 h-12 rounded-full bg-jester-purple/15 border border-jester hover:bg-jester-purple/30 text-white font-label tracking-[0.2em] text-sm uppercase transition-colors"
              >
                Book Your Coating
              </a>
            </div>
          </div>
        </div>
      </section>

      <SocialProof />
      <CuratedReviews showHeading={false} />
      <Contact />
      <Footer />
    </div>
  );
}
